module.exports = __webpack_public_path__ + "img/howtoplay-02.8301aaa5.jpg";